import type { ReactNode } from 'react';
import { cn } from '../lib/utils';

interface PageHeaderProps {
  title: ReactNode;
  /** Short line of context under the title. */
  subtitle?: ReactNode;
  /** Buttons for this page. Take the full row when space runs out. */
  actions?: ReactNode;
  className?: string;
}

/**
 * The standard title block for a page.
 *
 * Exists so no page hand-rolls its own flex row — the pattern that preceded it
 * (`justify-between` with no wrapping) pushed action buttons off the edge on a
 * portrait tablet.
 */
const PageHeader = ({ title, subtitle, actions, className }: PageHeaderProps) => (
  <div
    className={cn(
      'mb-6 flex flex-wrap items-start justify-between gap-4',
      className
    )}
  >
    <div className="min-w-0">
      <h1 className="font-sans text-2xl font-bold tracking-tight text-ink text-balance">
        {title}
      </h1>
      {subtitle && (
        <p className="mt-1 font-sans text-sm text-ink-soft">{subtitle}</p>
      )}
    </div>
    {actions && (
      <div className="flex w-full flex-wrap gap-2 sm:w-auto">{actions}</div>
    )}
  </div>
);

export default PageHeader;
